var map = {
	"./black/yinliangjia2.png": "c/J5",
	"./blue/yinliangjia2.png": "dFnC",
	"./white/yinliangjia2.png": "5QEj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+4OZ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/yinliangjia2\.png$
// module id = +4OZ
// module chunks = 24